
/* eslint-disable @typescript-eslint/no-shadow */
export namespace PublicAPIKeyStatus {
  export enum PublicAPIKeyStatus {
    ACTIVE = "ACTIVE",
    EXPIRED = "EXPIRED",
  }

  export interface PublicAPIKeyStatusDTO {
    case: string;
  }

  export const fromDTO = (dto: PublicAPIKeyStatusDTO): PublicAPIKeyStatus => {
    if (dto === undefined || dto === null) {
      throw new InvalidPublicAPIKeyStatusError(
        `Invalid DTO ${dto} provided for PublicAPIKeyStatus.PublicAPIKeyStatus`
      );
    }
    switch (dto.case) {
      case "ACTIVE":
        return PublicAPIKeyStatus.ACTIVE;
      case "EXPIRED":
        return PublicAPIKeyStatus.EXPIRED;
      default:
        throw new InvalidPublicAPIKeyStatusError(
          `Case ${dto.case} is not valid case of PublicAPIKeyStatus.PublicAPIKeyStatus`
        );
    }
  };

  export const toDTO = (publicApiKeyStatus: PublicAPIKeyStatus): PublicAPIKeyStatusDTO => {
    const enumDTO = {
      case: PublicAPIKeyStatus[publicApiKeyStatus],
    };
    return enumDTO;
  };
}

export class InvalidPublicAPIKeyStatusError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPublicAPIKeyStatusError";
  }
}
export class InvalidPublicAPIKeyStatusActiveError extends InvalidPublicAPIKeyStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPublicAPIKeyStatusActiveError";
  }
}

export class InvalidPublicAPIKeyStatusExpiredError extends InvalidPublicAPIKeyStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPublicAPIKeyStatusExpiredError";
  }
}
